import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { fetchWrapper } from 'util/api';
import {
  standardDivisionAge
} from 'util/standardDivisions';
import {
  getLifterUSAPLDivision,
  getLifterUSAPLWeightClass
} from 'util/federations/usapl';

import {
  getCurrentMeet,
  getLifter
} from 'selectors';

const RecordsForType = ({records, type, gender, rawOrEquipped, code, weightClassName}) => {
  const eligibleRecords = _.get(records, [type, gender, rawOrEquipped, code, weightClassName]);

  return (
    <div className="records-for-type">
      <div className="record-title">{type} {gender} {rawOrEquipped} {code} {weightClassName}</div>
      { eligibleRecords &&
        _.map(eligibleRecords, (weight, name) => {
          return (
            <div key={name}><label>{name}:</label> {weight} kg</div>
          );
        })
      }
      { !eligibleRecords &&
        <div>blank</div>
      }
    </div>
  );
};

class EligibleRecords extends Component {
  state = {
    records: {},
    loading: true,
    error: false
  }
  componentDidMount() {
    this.setState({loading: true});
    fetchWrapper('/data/records.json', 'GET').then((response) => {
      this.setState({records: response, loading: false});
    }).catch(() => {
      this.setState({records: {}, loading: false, error: true});
      console.error('Failed to load records data');
    });
  }

  render() {
    const { lifter, meet } = this.props;
    const gender = _.get(lifter, 'gender');

    const isRaw = !_.find(_.get(lifter, 'divisions'), {rawOrEquipped: 'EQUIPPED'});
    const rawOrEquipped = isRaw ? 'RAW' : 'EQUIPPED';
    const isCollegiate = _.has(_.get(lifter, 'divisions'), {usaplDivisionCode: 'C'});
    const standardDivision = getLifterUSAPLDivision(lifter, meet);
    const code = _.get(standardDivision, 'code');

    const standardWeightClass = getLifterUSAPLWeightClass(lifter, standardDivision.code, meet);
    const weightClassName = _.get(standardWeightClass, 'name');

    const age = standardDivisionAge(lifter, meet);

    if(!weightClassName || !age || !code) {
      return null;
    }

    if(this.state.loading) {
      return (
        <div>Loading...</div>
      );
    }

    if(this.state.error) {
      return (
        <div>Failed to load records</div>
      );
    }

    const eligibleRecords = [
      {gender, rawOrEquipped, code, weightClassName}
    ];

    if(age >= 14 && code !== 'O') {
      eligibleRecords.push({gender, rawOrEquipped, code: 'O', weightClassName});
    }

    if(isCollegiate) {
      eligibleRecords.push({gender, rawOrEquipped, code: 'C', weightClassName});
    }

    if(_.find(eligibleRecords, {code: 'M6'})) {
      eligibleRecords.push({gender, rawOrEquipped, code: 'M5b', weightClassName});
    }

    if(_.find(eligibleRecords, {code: 'M5b'})) {
      eligibleRecords.push({gender, rawOrEquipped, code: 'M5a', weightClassName});
    }

    if(_.find(eligibleRecords, {code: 'M5a'})) {
      eligibleRecords.push({gender, rawOrEquipped, code: 'M4b', weightClassName});
    }

    if(_.find(eligibleRecords, {code: 'M4b'})) {
      eligibleRecords.push({gender, rawOrEquipped, code: 'M4a', weightClassName});
    }

    if(_.find(eligibleRecords, {code: 'M4a'})) {
      eligibleRecords.push({gender, rawOrEquipped, code: 'M3b', weightClassName});
    }

    if(_.find(eligibleRecords, {code: 'M3b'})) {
      eligibleRecords.push({gender, rawOrEquipped, code: 'M3a', weightClassName});
    }

    if(_.find(eligibleRecords, {code: 'M3a'})) {
      eligibleRecords.push({gender, rawOrEquipped, code: 'M2b', weightClassName});
    }

    if(_.find(eligibleRecords, {code: 'M2b'})) {
      eligibleRecords.push({gender, rawOrEquipped, code: 'M2a', weightClassName});
    }

    if(_.find(eligibleRecords, {code: 'M2a'})) {
      eligibleRecords.push({gender, rawOrEquipped, code: 'M1b', weightClassName});
    }

    if(_.find(eligibleRecords, {code: 'M1b'})) {
      eligibleRecords.push({gender, rawOrEquipped, code: 'M1a', weightClassName});
    }

    if(_.find(eligibleRecords, {code: 'T1'})) {
      eligibleRecords.push({gender, rawOrEquipped, code: 'T2', weightClassName});
    }

    if(_.find(eligibleRecords, {code: 'T2'})) {
      eligibleRecords.push({gender, rawOrEquipped, code: 'T3', weightClassName});
    }

    if(_.find(eligibleRecords, {code: 'T3'})) {
      eligibleRecords.push({gender, rawOrEquipped, code: 'Jr', weightClassName});
    }

    return (
      <div>
        <div>
          Eligible USAPL Records. Check with meet staff to see if American Records can be broken.
        </div>
        {
          _.map(eligibleRecords, (er) => {
            return (
              <RecordsForType
                key={`${er.gender}-${er.rawOrEquipped}-${er.code}-${er.weightClassName}`}
                type="AMERICAN"
                gender={er.gender}
                rawOrEquipped={er.rawOrEquipped}
                code={er.code}
                weightClassName={er.weightClassName}
                records={this.state.records}
              />
            );
          })
        }
        { lifter.state &&
          _.map(eligibleRecords, (er) => {
            return (
              <RecordsForType
                key={`${er.gender}-${er.rawOrEquipped}-${er.code}-${er.weightClassName}`}
                type={lifter.state}
                gender={er.gender}
                rawOrEquipped={er.rawOrEquipped}
                code={er.code}
                weightClassName={er.weightClassName}
                records={this.state.records}
              />
            );
          })
        }
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    meet: getCurrentMeet(state, props),
    lifter: getLifter(state, props)
  };
};

const actions = {};

export default withRouter(connect(mapStateToProps, actions)(EligibleRecords));
